import { render, staticRenderFns } from "./dealerOrderSave.vue?vue&type=template&id=2fd7bd38&scoped=true&"
import script from "./dealerOrderSave.vue?vue&type=script&lang=js&"
export * from "./dealerOrderSave.vue?vue&type=script&lang=js&"
import style0 from "./dealerOrderSave.vue?vue&type=style&index=0&id=2fd7bd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd7bd38",
  null
  
)

export default component.exports